module.exports = __webpack_public_path__ + "static/media/ic-person-selected.5059eafe.svg";